import React, { useEffect, useRef, useState } from 'react'
import { Chart as ChartJS, Tooltip, ArcElement } from "chart.js";
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(Tooltip, ArcElement);

const Donut = ({ data, tableRowId, largestHoldings }) => {
    const [isDonutHover, setIsDonutHover] = useState(false);
    // const [largestHoldingsPercentages, setLargestHoldingPercentages] = useState(0);
    const chartRef = useRef(null);
    const largestHoldingsData = data.filter(item => largestHoldings.includes(item.id));
    const largestHoldingsPercentages = largestHoldingsData.reduce((percentage, item) => {
        return percentage + item.holding_pct;
    }, 0);
    const holdingPercentagesRef = useRef(largestHoldingsPercentages);

    useEffect(() => {
       holdingPercentagesRef.current = largestHoldingsPercentages;
    }, [largestHoldings])

    // useEffect(() => {
    //     console.log('testing');
    //     const largestHoldingsData = data.filter(item => largestHoldings.includes(item.id));
    //     const percentages = largestHoldingsData.reduce((percentage, item) => {
    //         return percentage + item.holding_pct;
    //     }, 0);

    //     setLargestHoldingPercentages(percentages);

    // }, [largestHoldings])

    

    // this useEffect is to detect if the mouse has left the canvas
    // this is needed because onHover does not always accurately detect that the mouse is off hover
    // once off hover, the static/largest holdings tooltips should show
    useEffect(() => {
        const checkMousePosition = (event) => {
            if (chartRef.current) {
                const canvas = chartRef.current.canvas;
                const canvasRect = canvas.getBoundingClientRect();
                const mouseX = event.clientX;
                const mouseY = event.clientY;
            
                // if mouse is inside canvas
                if (
                    mouseX >= canvasRect.left && 
                    mouseX <= canvasRect.right && 
                    mouseY >= canvasRect.top &&
                    mouseY <= canvasRect.bottom
                ) return;
                
                setIsDonutHover(false);
            }
        }
        // Add global mousemove event listener
        window.addEventListener('mousemove', checkMousePosition);

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener('mousemove', checkMousePosition);
        };
    }, []);
    

    // this useEffect is to detect if a row in a table has been hovered
    // if hovered show tooltip on donut
    // also if nothing is hovered show top 5 holdings
    useEffect(() => {
        const chartInstance = chartRef.current;
        if(!chartInstance) return;
        
        // reset active element
        if(tableRowId === null) {
            chartInstance.setActiveElements([]);
            chartInstance.tooltip.setActiveElements([]);
        }

        // handle table hover
        if(tableRowId !== null) {
            const datasetIndex = 0;
            const index = data.findIndex((item => item.id === tableRowId));

            if(index >= 0) {
                // set arc as active element
                chartInstance.setActiveElements([{ datasetIndex, index }]);

                // set tooltip as active element
                chartInstance.tooltip.setActiveElements([{ datasetIndex, index }]);
            }
        }

        // show largest holdings when nothing is hovered
        // if(tableRowId === null && !isDonutHover) {
        //     const largestHoldingsElements = data.reduce((elements, item, index) => {
        //         const datasetIndex = 0;
        //         if(largestHoldings.includes(item.id)) {
        //             elements.push({ datasetIndex, index })
        //         }
    
        //         return elements;
        //     }, []);

        //     chartInstance.setActiveElements(largestHoldingsElements);
        //     chartInstance.tooltip.setActiveElements(largestHoldingsElements);
        // }
        
        if(tableRowId === null && !isDonutHover) {
            chartInstance.setActiveElements([]);
            chartInstance.tooltip.setActiveElements([]);
            document.querySelectorAll('.chartjs-tooltip').forEach(element => element.remove());

            // Create Tooltip
            let tooltipElement = document.getElementById(`chartjs-tooltip-0`)
            if(tooltipElement) return;

            tooltipElement = document.createElement('div');
            tooltipElement.id = `chartjs-tooltip-0`;
            tooltipElement.className = 'chartjs-tooltip';
            tooltipElement.innerHTML = '<div></div>';
            document.body.appendChild(tooltipElement);
            
            const text = 'Top 5 Holding Percentages';

            const label = `<span style="font-weight: bold; margin-right: 4px;">${text}</span>`;
            const percentage = `${holdingPercentagesRef.current.toFixed(2)}%`;
            const innerHTML = `<div class= >${label} ${percentage}</div>`
            let tooltipRoot = tooltipElement.querySelector('div');
            tooltipRoot.innerHTML = innerHTML;

            const context = chartInstance.$context;
            // Get chart position
            const position = context.chart.canvas.getBoundingClientRect();
    
            // Find the center of the chart
            const centerX = position.left + window.scrollX + context.chart.width / 2;
            const centerY = position.top + window.scrollY + context.chart.height / 2;

            tooltipElement.style.position = 'absolute';
            tooltipElement.style.pointerEvents = 'none';
            tooltipElement.style.left = `${centerX}px`;
            tooltipElement.style.top = `${centerY}px`;
            tooltipElement.style.transform = `translate(-50%, -50%)`;
            tooltipElement.style.width = '82.15px';
            tooltipElement.style.textAlign = 'center';
        }

        return () => {
            // Cleanup function to reset tooltips on unmount/navigation
            // if (chartInstance) {
            //     chartInstance.setActiveElements([]); // Clear active elements
            // }

            // clean up tooltip before rendering
            document.querySelectorAll('.chartjs-tooltip').forEach(element => element.remove());
            // document.querySelectorAll('.chartjs-tooltip-caret').forEach(element => element.remove());
        };
    }, [data, tableRowId, isDonutHover]);


    // Convert data to donut data
    const { symbols, holdingPercentages, colors } = data.reduce((dataObj, item) => {
        const { symbols, holdingPercentages, colors } = dataObj;
        const { r, g, b } = item.color;

        symbols.push(item.popup);
        holdingPercentages.push(parseFloat(item.holding_pct.toFixed(2)));
        colors.push(`rgb(${r},${g},${b})`);

        return dataObj;
    }, { symbols: [], holdingPercentages: [], colors: [] })
    
    // Data for donut chart
    const dounutData = {
        labels: symbols,
        datasets: [{
            data: holdingPercentages,
            backgroundColor: colors
        }]
    }

    // Options for donut chart
    const donutOptions = {
        cutout: "65%",
        spacing: 0,
        rotation: 90,
        elements: {
            arc: {
                borderWidth: 1,
            }
        },
        layout: {
        },
        onHover: (event, elements) => {
            setIsDonutHover(elements.length !== 0);
            if (elements.length) {
                event.native.target.style.cursor = "pointer"; // Show pointer when hovering over segments
              } else {
                event.native.target.style.cursor = "default"; // Default when not hovering
            }
        },
        animation: false,
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                enabled: false,
                external: function(context) {
                    const { chart, tooltip } = context;
                    if(!chart) return;

                    document.querySelectorAll('.chartjs-tooltip').forEach(element => element.remove());
                    // const activeElements = chart.getActiveElements();

                    tooltip.dataPoints.forEach((dataPoint, index) => {
                        let tooltipElement = document.getElementById(`chartjs-tooltip-${index}`);
                        if(!tooltipElement) {
                            tooltipElement = document.createElement('div');
                            tooltipElement.id = `chartjs-tooltip-${index}`;
                            tooltipElement.className = 'chartjs-tooltip';
                            tooltipElement.innerHTML = '<div></div>';
                            document.body.appendChild(tooltipElement);
                        }

                        // const text = activeElements.length === 0 ? 'Top 5 Total Holding Percentages' : dataPoint.label;
                        // const percent = activeElements.length === 0 ? holdingPercentagesRef.current.toFixed(2) : dataPoint.parsed;
    
                        const label = `<span style="font-weight: bold; margin-right: 4px;">${dataPoint.label}</span>`;
                        const percentage = `${dataPoint.parsed}%`;
                        const innerHTML = `<div class= >${label} ${percentage}</div>`
                        let tooltipRoot = tooltipElement.querySelector('div');
                        tooltipRoot.innerHTML = innerHTML;
    
                        // Get chart position
                        const position = context.chart.canvas.getBoundingClientRect();
    
                        // Find the center of the chart
                        const centerX = position.left + window.scrollX + context.chart.width / 2;
                        const centerY = position.top + window.scrollY + context.chart.height / 2;
    
                        tooltipElement.style.position = 'absolute';
                        tooltipElement.style.pointerEvents = 'none';
                        tooltipElement.style.left = `${centerX}px`;
                        tooltipElement.style.top = `${centerY}px`;
                        tooltipElement.style.transform = `translate(-50%, -50%)`;
                        tooltipElement.style.width = '82.15px';
                        tooltipElement.style.textAlign = 'center';
                    })
                }
                
                // Actual ToolTip
                // external: function(context) {
                //     if(!context.chart) return;

                //     // clean up tooltip before rendering
                //     document.querySelectorAll('.chartjs-tooltip').forEach(element => element.remove());
                //     document.querySelectorAll('.chartjs-tooltip-caret').forEach(element => element.remove());

                //     const toolTipModel = context.tooltip;
                //     const toolTips = toolTipModel.dataPoints.reduce((toolTips, dataPoint, index) => {
     
                //         // Create ToolTip if it does not already exists
                //         let toolTip = document.getElementById(`chartjs-tooltip-${index}`);
                //         if(!toolTip) {
                //             toolTip = document.createElement('div');
                //             toolTip.id = `chartjs-tooltip-${index}`;
                //             toolTip.className = 'chartjs-tooltip'
                //             toolTip.innerHTML = '<div></div>'
                //             document.body.appendChild(toolTip);
                //         }

                //         // set body
                //         const label = `<span style="font-weight: bold; margin-right: 4px;">${dataPoint.label}</span>`;
                //         const percentage = `${dataPoint.parsed} %`;
                //         const innerHTML = `<div class= >${label} ${percentage}</div>`
                    
                //         let toolTipRoot = toolTip.querySelector('div');
                //         toolTipRoot.innerHTML = innerHTML;                     

                //          // Get chart position
                //         const position = context.chart.canvas.getBoundingClientRect();

                //         // Find the center of the chart
                //         const centerX = position.left + window.scrollX + context.chart.width / 2;
                //         const centerY = position.top + window.scrollY + context.chart.height / 2;

                //         const { startAngle, endAngle, outerRadius, innerRadius } = dataPoint.element;
                //         // Calculate arc midpoint angle
                //         const midAngle = (startAngle + endAngle) / 2;

                //         // Calculate the tooltip position using polar to Cartesian conversion
                //         const radius = outerRadius + 20;
                //         let toolTipX = centerX + radius * Math.cos(midAngle);
                //         let toolTipY = centerY + radius * Math.sin(midAngle);

                //         toolTip.style.opacity = 0;
                //         toolTip.style.position = 'absolute';
                //         toolTip.style.padding = '4px 10px';
                //         toolTip.style.pointerEvents = 'none';
                //         toolTip.style.backgroundColor = '#fff'
                //         toolTip.style.border = "1px solid #efefef";
                //         toolTip.style.boxShadow = "0 3px 5px rgba(0, 0, 0, 0.2)";

                //         // Create Caret/Line Element
                //         let caret = document.getElementById(`chartjs-tooltip-caret-${index}`);
                //         if(!caret) {
                //             caret = document.createElement('div');
                //             caret.id = `chartjs-tooltip-caret-${index}`;
                //             caret.className = `chartjs-tooltip-caret`;
                //             caret.style.position = "absolute";
                //             caret.style.background = "black";
                //             caret.style.height = "2px";
                //             caret.style.pointerEvents = 'none';
                //             document.body.appendChild(caret);
                //         }

                //         toolTips.push({
                //             caret,
                //             toolTip,
                //             toolTipX,
                //             toolTipY,
                //             centerX,
                //             centerY,
                //             outerRadius,
                //             innerRadius,
                //             midAngle,
                //         })

                //         return toolTips;
                //     }, [])

                //     requestAnimationFrame(() => { 
                //         // note origin (0, 0) starts from top left corner of webpage
                //         // so center Y is not (0, 0), center Y is some positive number
                //         // also the higher the Y value, the lower Y coordinate is
                //         // for instance 100px for the Y coordinate is 100px downwards
                        
                //         toolTips.forEach(({ caret, toolTip, toolTipX, centerX, toolTipY, centerY, outerRadius, innerRadius, midAngle }) => {
                //             const toolTipWidth = toolTip.offsetWidth;
                //             const toolTipHeight = toolTip.offsetHeight;
                //             let adjustedToolTipX = toolTipX;
                //             let adjustedToolTipY = toolTipY;
                //             if(toolTipX > centerX && toolTipY < centerY) {
                //                 // 1st Quadrant (bottom left corner)
                //                 adjustedToolTipY = toolTipY - toolTipHeight;
                //             } else if(toolTipX < centerX && toolTipY < centerY) {
                //                 // 2nd Quadrant (bottom right corner)
                //                 adjustedToolTipX = toolTipX - toolTipWidth;
                //                 adjustedToolTipY = toolTipY - toolTipHeight;
                //             } else if(toolTipX < centerX && toolTipY > centerY) {
                //                 // 3rd Quadrant (top right corner)
                //                 adjustedToolTipX = toolTipX - toolTipWidth;
                //             }

                //             // the coordinates here need to be relative window
                //             toolTip.style.left = `${adjustedToolTipX}px`;
                //             toolTip.style.top = `${adjustedToolTipY}px`;
                //             toolTip.style.opacity = 1;

                //             const radiusLine = (outerRadius + innerRadius) / 2;
                //             const startX = centerX + radiusLine * Math.cos(midAngle);
                //             const startY = centerY + radiusLine * Math.sin(midAngle);
                //             const deltaX = toolTipX - startX;
                //             const deltaY = toolTipY - startY;
                //             const length = Math.sqrt(deltaX ** 2 + deltaY ** 2);
                //             const angle = Math.atan2(deltaY, deltaX) * (180 / Math.PI);
                            
                //             caret.style.width = `${length}px`;
                //             caret.style.transform = `rotate(${angle}deg)`;
                //             caret.style.left = `${startX}px`;
                //             caret.style.top = `${startY}px`;
                //             caret.style.transformOrigin = "0 50%";
                //         })
                //     })
                // }
            },
        },
    }

    const centerText = {
        id: 'centerText',
        afterRender(chart, args, pluginOptions) {
            const { $context: context } = chart;

            // console.log('in center text before check')
            let tooltipElement = document.getElementById(`chartjs-tooltip-0`)
            // console.log('tooltipelement before check', tooltipElement);
            if(tooltipElement) return;

            tooltipElement = document.createElement('div');
            tooltipElement.id = `chartjs-tooltip-0`;
            tooltipElement.className = 'chartjs-tooltip';
            tooltipElement.innerHTML = '<div></div>';
            document.body.appendChild(tooltipElement);
            
            const text = 'Top 5 Holding Percentages';

            const label = `<span style="font-weight: bold; margin-right: 4px;">${text}</span>`;
            const percentage = `${holdingPercentagesRef.current.toFixed(2)}%`;
            const innerHTML = `<div class= >${label} ${percentage}</div>`
            let tooltipRoot = tooltipElement.querySelector('div');
            tooltipRoot.innerHTML = innerHTML;

            // Get chart position
            const position = context.chart.canvas.getBoundingClientRect();
    
            // Find the center of the chart
            const centerX = position.left + window.scrollX + context.chart.width / 2;
            const centerY = position.top + window.scrollY + context.chart.height / 2;

            tooltipElement.style.position = 'absolute';
            tooltipElement.style.pointerEvents = 'none';
            tooltipElement.style.left = `${centerX}px`;
            tooltipElement.style.top = `${centerY}px`;
            tooltipElement.style.transform = `translate(-50%, -50%)`;
            tooltipElement.style.width = '82.15px';
            tooltipElement.style.textAlign = 'center';
        }
    }

    return (
        <div style={{ position: 'relative', maxHeight: '250px', maxWidth: '250px' }}>
            <Doughnut ref={chartRef} data={dounutData} options={donutOptions} plugins={[centerText]}/>
        </div>
    )
}

export default Donut